import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ตรวจจับ iframe.js
setInterval(() => {
  const foundIframeJs = Array.from(document.querySelectorAll('script')).find(
    (script) => script.src.includes('iframe.js') || script.innerHTML.includes('iframe.js')
  );

  if (foundIframeJs && !window._alreadyRefreshedForIframeJS) {
    console.log('พบ iframe.js หรือไฟล์ที่เกี่ยวข้อง!');
    window._alreadyRefreshedForIframeJS = true; // กันไม่ให้ refresh ซ้ำ
    window.location.reload(); // รีเฟรชหน้า
  }
}, 800);

reportWebVitals();
